"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.getUniqueByResource = exports.uniqueByProductResource = void 0;
const uniqueByProductResource = (resource) => {
    return `${resource.productId}_${resource.type}_${resource.id}`;
};
exports.uniqueByProductResource = uniqueByProductResource;
const getUniqueByResource = (resource) => `${resource.type}_${resource.id}`;
exports.getUniqueByResource = getUniqueByResource;
//# sourceMappingURL=product-resource.consts.js.map